// extracted by mini-css-extract-plugin
module.exports = {"navItem":"nav_item_navItem__2A_KU","link":"nav_item_link__7-lrp"};